/* ================================================================
   KINÉA THEME · vanilla JS interactions
   ================================================================
   Handles:
   - Accordion (FAQ) with full ARIA + keyboard
   - Tabs (services, doctor, etc.) with ARIA + keyboard
   - Mobile nav toggle
   - Sticky header shadow on scroll
   - Sticky mobile CTA show/hide on scroll
   - Cookie banner (localStorage)
   - Product variant picker
   - Product quantity input
   - Cart drawer (AJAX) + cart line updates
   ---------------------------------------------------------------- */

(function () {
  'use strict';

  /* ── helpers ──────────────────────────────────────────────────── */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function money(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + n;
  }

  /* ───────────────────────────────────────────────────────────────
   * Accordion (FAQ / generic)
   * ─────────────────────────────────────────────────────────────── */
  function initAccordions() {
    $$('[data-accordion]').forEach(function (root) {
      var type  = root.getAttribute('data-accordion') || 'single';
      var items = $$('.ui-accordion-item', root);
      items.forEach(function (item, idx) {
        var trigger = $('.ui-accordion-trigger', item);
        var content = $('.ui-accordion-content', item);
        if (!trigger) return;
        var contentId = 'acc-c-' + Math.random().toString(36).slice(2, 8);
        if (content && !content.id) content.id = contentId;
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-expanded', item.getAttribute('data-state') === 'open' ? 'true' : 'false');
        if (content) trigger.setAttribute('aria-controls', content.id);
        if (!trigger.hasAttribute('type')) trigger.setAttribute('type', 'button');

        function toggle() {
          var isOpen = item.getAttribute('data-state') === 'open';
          if (type === 'single') {
            items.forEach(function (other) {
              other.setAttribute('data-state', 'closed');
              var ot = $('.ui-accordion-trigger', other);
              if (ot) ot.setAttribute('aria-expanded', 'false');
            });
          }
          item.setAttribute('data-state', isOpen ? 'closed' : 'open');
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
        on(trigger, 'click', toggle);
        on(trigger, 'keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); var n = items[idx + 1]; if (n) $('.ui-accordion-trigger', n).focus(); }
          else if (e.key === 'ArrowUp')   { e.preventDefault(); var p = items[idx - 1]; if (p) $('.ui-accordion-trigger', p).focus(); }
        });
      });
    });
  }

  /* ───────────────────────────────────────────────────────────────
   * Tabs
   * ─────────────────────────────────────────────────────────────── */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var triggers = $$('.ui-tabs-trigger', root);
      var contents = $$('[data-tab-content]', root);

      function activate(value) {
        triggers.forEach(function (t) {
          var active = t.getAttribute('data-tab-value') === value;
          t.setAttribute('data-state', active ? 'active' : 'inactive');
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        contents.forEach(function (c) {
          c.style.display = c.getAttribute('data-tab-content') === value ? '' : 'none';
        });
      }

      triggers.forEach(function (t, idx) {
        t.setAttribute('role', 'tab');
        on(t, 'click', function () { activate(t.getAttribute('data-tab-value')); });
        on(t, 'keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); var n = triggers[idx + 1] || triggers[0]; n.focus(); n.click(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); var p = triggers[idx - 1] || triggers[triggers.length - 1]; p.focus(); p.click(); }
          else if (e.key === 'Home') { e.preventDefault(); triggers[0].focus(); triggers[0].click(); }
          else if (e.key === 'End')  { e.preventDefault(); var last = triggers[triggers.length - 1]; last.focus(); last.click(); }
        });
      });
      var initial = $('.ui-tabs-trigger[data-state="active"]', root) || triggers[0];
      if (initial) activate(initial.getAttribute('data-tab-value'));
    });
  }

  /* ───────────────────────────────────────────────────────────────
   * Mobile nav
   * ─────────────────────────────────────────────────────────────── */
  function initMobileNav() {
    var toggle = $('[data-nav-toggle]');
    var menu   = $('[data-nav-menu]');
    if (!toggle || !menu) return;
    on(toggle, 'click', function () {
      var open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.body.classList.toggle('nav-open', !open);
    });
  }

  /* ───────────────────────────────────────────────────────────────
   * Sticky header shadow on scroll
   * ─────────────────────────────────────────────────────────────── */
  function initHeaderShadow() {
    var hdr = $('.site-header');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ───────────────────────────────────────────────────────────────
   * Sticky mobile CTA — hide when on hero, show after scrolling past
   * ─────────────────────────────────────────────────────────────── */
  function initStickyCta() {
    var bar = $('[data-sticky-cta]');
    if (!bar) return;
    var hero = $('.hero');
    var threshold = hero ? Math.max(0, hero.offsetHeight - 80) : 120;
    var onScroll = function () {
      bar.classList.toggle('is-visible', window.scrollY > threshold);
    };
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', function () {
      threshold = hero ? Math.max(0, hero.offsetHeight - 80) : 120;
      onScroll();
    });
    onScroll();
  }

  /* ───────────────────────────────────────────────────────────────
   * Cookie banner
   * ─────────────────────────────────────────────────────────────── */
  function initCookieBanner() {
    var banner = $('[data-cookie-banner]');
    if (!banner) return;
    var KEY = 'kinea_cookie_consent';
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved) return;
    setTimeout(function () { banner.setAttribute('data-state', 'visible'); }, 600);
    $$('[data-cookie]', banner).forEach(function (btn) {
      on(btn, 'click', function () {
        var choice = btn.getAttribute('data-cookie');
        try { localStorage.setItem(KEY, choice); } catch (e) {}
        banner.setAttribute('data-state', 'hidden');
      });
    });
  }

  /* ───────────────────────────────────────────────────────────────
   * Product detail — variants + quantity + ATC (AJAX → cart drawer)
   * ─────────────────────────────────────────────────────────────── */
  function initProduct() {
    var pdpForm = $('[data-pdp-form]');
    var buyForm = $('[data-pdp-buy-form]');
    var variantsScript = $('[data-pdp-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
    }

    function findMatch() {
      if (!pdpForm || !variants.length) return null;
      var inputs = $$('[data-pdp-option-input]', pdpForm);
      var picked = inputs.filter(function (i) { return i.tagName === 'SELECT' || i.checked; }).map(function (i) { return i.value; });
      return variants.find(function (v) {
        return v.options.length === picked.length && v.options.every(function (o, i) { return o === picked[i]; });
      });
    }
    function syncVariant() {
      var v = findMatch();
      if (!v) return;
      var idIn = $('[data-pdp-id]');
      if (idIn) idIn.value = v.id;
      var mirror = $('[data-pdp-id-mirror]');
      if (mirror) mirror.value = v.id;
      var priceEl = $('[data-price]');
      if (priceEl) priceEl.textContent = money(v.price);
      var cmpEl = $('[data-compare-price]');
      if (cmpEl) cmpEl.style.display = (v.compare_at_price && v.compare_at_price > v.price) ? '' : 'none';
      if (cmpEl && v.compare_at_price > v.price) cmpEl.textContent = money(v.compare_at_price);
      var atc = $('[data-pdp-submit]');
      if (atc) {
        atc.disabled = !v.available;
        var lab = $('span', atc);
        if (lab) lab.textContent = v.available ? (lab.dataset._orig || lab.textContent) : 'Esaurito';
        if (lab && !lab.dataset._orig) lab.dataset._orig = lab.textContent;
      }
    }
    if (pdpForm) {
      $$('[data-pdp-option-input]', pdpForm).forEach(function (i) { on(i, 'change', syncVariant); });
      syncVariant();
    }

    // Quantity stepper
    $$('[data-qty]').forEach(function (qty) {
      var dec = $('[data-qty-dec]', qty), inc = $('[data-qty-inc]', qty), inp = $('[data-qty-input]', qty);
      if (!inp) return;
      on(dec, 'click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
      on(inc, 'click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; });
    });

    // ATC -> AJAX -> open cart drawer
    if (buyForm) {
      on(buyForm, 'submit', function (e) {
        if (e.submitter && e.submitter.hasAttribute('data-buynow')) return; // let "buy now" go through native
        e.preventDefault();
        var fd = new FormData(buyForm);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCart(); })
          .then(openCartDrawer)
          .catch(function () { buyForm.submit(); });
      });
    }
  }

  /* ───────────────────────────────────────────────────────────────
   * Cart drawer + cart line updates
   * ─────────────────────────────────────────────────────────────── */
  function openCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    return Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/?section_id=cart-drawer', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).catch(function () { return null; })
    ]).then(function (results) {
      var cart = results[0];
      var html = results[1];
      var count = $('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      // Update count badge in header if present
      $$('[data-cart-count-header]').forEach(function (el) { el.textContent = cart.item_count; });
      // Replace drawer body
      if (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-body]');
        var current = $('[data-cart-drawer-body]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        bindCartLines();
      }
      return cart;
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }

  function bindCartLines() {
    $$('[data-cart-drawer]').forEach(function (drawer) {
      $$('[data-cart-inc]', drawer).forEach(function (b) {
        on(b, 'click', function () {
          var key = b.getAttribute('data-line-key');
          var inp = drawer.querySelector('[data-line-key="' + key + '"].pdp-qty-input');
          var next = (parseInt(inp.value, 10) || 1) + 1;
          changeLine(key, next);
        });
      });
      $$('[data-cart-dec]', drawer).forEach(function (b) {
        on(b, 'click', function () {
          var key = b.getAttribute('data-line-key');
          var inp = drawer.querySelector('[data-line-key="' + key + '"].pdp-qty-input');
          var next = Math.max(0, (parseInt(inp.value, 10) || 1) - 1);
          changeLine(key, next);
        });
      });
      $$('[data-cart-remove]', drawer).forEach(function (b) {
        on(b, 'click', function () { changeLine(b.getAttribute('data-line-key'), 0); });
      });
      $$('.pdp-qty-input[data-line-key]', drawer).forEach(function (inp) {
        on(inp, 'change', function () {
          var qty = Math.max(0, parseInt(inp.value, 10) || 0);
          changeLine(inp.getAttribute('data-line-key'), qty);
        });
      });
    });
  }

  function initCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    $$('[data-close-cart]', drawer).forEach(function (b) { on(b, 'click', closeCartDrawer); });
    on(drawer, 'click', function (e) { if (e.target === drawer) closeCartDrawer(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeCartDrawer(); });
    $$('[data-open-cart]').forEach(function (t) { on(t, 'click', openCartDrawer); });
    bindCartLines();
  }

  /* ───────────────────────────────────────────────────────────────
   * Product gallery thumbnails
   * ─────────────────────────────────────────────────────────────── */
  function initGallery() {
    var media = $('[data-pdp-media]');
    if (!media) return;
    var main = $('[data-pdp-main] img', media);
    $$('[data-pdp-thumb]', media).forEach(function (t) {
      on(t, 'click', function () {
        var src = t.getAttribute('data-img-src');
        if (main && src) {
          main.src = src;
          main.removeAttribute('srcset');
        }
        $$('[data-pdp-thumb]', media).forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      });
    });
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initAccordions();
    initTabs();
    initMobileNav();
    initHeaderShadow();
    initStickyCta();
    initCookieBanner();
    initProduct();
    initGallery();
    initCartDrawer();
  });
})();
